import Vue from 'vue'
Vue.prototype.$_ = require('lodash')
Vue.prototype.$Tone = require('tone')


// WEBPACK FOOTER //
// ./client/plugins/add_to_prototype.js